module.exports = __webpack_public_path__ + "static/media/ic-v-badge-cn.b99b3a44.png";